<template>
	<div class="shpmy">
			
			<!--<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" >-->
			<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" size="sm" data-backdrop="static" no-close-on-backdrop>
			<template #modal-header>
      		  
			  <h5 class="modal-title"> Change Password</h5>
			 
			  <!--<button type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModal')" class="close">×</button> -->
			</template>
				<form ref="form">
				
				
			
				<b-form-group :state="registerState.new_password" label="New Password" label-size="sm" label-for="fpassword-input" :invalid-feedback="registerError.new_password"  label-class="mb-0" class="mb-1" >
				<b-form-input type="password" id="fpassword-input" v-model="register.new_password"  size="sm" @focusin="registerState.new_password = null,error_msg=''" ></b-form-input>
				</b-form-group>
								
				<b-form-group :state="registerState.conformpassword" label="Confirm password" label-size="sm" label-for="fcpassword-input" :invalid-feedback="registerError.conformpassword"  label-class="mb-0" class="mb-1" >
				<b-form-input type="password" id="fcpassword-input" v-model="register.conformpassword" size="sm" @focusin="registerState.conformpassword = null,error_msg=''" ></b-form-input>
				</b-form-group>
				
				
				  <!--<b-form-group label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
					<b-form-input v-model="coform_password" type="password"  required></b-form-input>
				  </b-form-group>
				  <b-form-group label="New Password" label-cols="4" label-size="sm" label-align-sm="right">
					<b-form-input v-model="new_password" type="password" :state="passwordState" required></b-form-input>
					<b-form-invalid-feedback id="input-live-feedback">
					  Enter at least 4 letters
					</b-form-invalid-feedback>
				  </b-form-group> -->
				</form>
				<template v-slot:modal-footer="{ }">
				<!--<b-button size="sm" variant="danger" @click="close()">Cancel</b-button> -->
				  <b-button size="sm" variant="success"  @click="modalSubmit">Change Password</b-button>
				</template>
			  </b-modal>


	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	userData: { type: Array},	
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		 coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		modalSubmit(){
				var valid = true;
				
				var passwordval =this.register.new_password;
			
					if(this.register.new_password==''){
						this.registerError.new_password='Please enter password!';
						valid = false;
						this.registerState.new_password = false; 
					}else if(this.register.new_password.length < 6){
						this.registerError.new_password='Password should be 6-12 characters long!';
						valid = false;
						this.registerState.new_password = false;
					
					}else{
					this.registerState.new_password = true;
					}
					
					if(this.register.conformpassword.length <1){
							this.registerError.conformpassword='Please enter confirm password!';
							valid = false;
							this.registerState.conformpassword = false;
						
					}else if(passwordval!=this.register.conformpassword){
							this.registerError.conformpassword='Password  and confirm password  is not identical';
							valid = false;
							this.registerState.conformpassword = false;
						
						}else{
						
						
						this.registerState.conformpassword = true;
						}
					//return valid;

				/* if(this.coform_password=='') {
					this.coform_passwordState= false;
					valid = false;
				}else this.coform_passwordState = true;
				
			if(this.new_password.length<4) {
					this.new_passwordState = false;
					valid = false;
				}else this.new_passwordState = true; */
				
				if(valid){
		
		
				  var self = this;
				  //self.loading = true;
				  //bvModalEvt.preventDefault();
				  var submitUrl = self.passwordUrl;
				  
		

				  var o = {'cp': self.register.conformpassword, 'np': self.register.new_password};

				  self.axios.post(submitUrl, {
					accesskey: self.$session.get('access_key'),
					data: o
				  })
				  .then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
					  //self.$bvModal.hide('my-modal');
					  self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
					  });
					  
					  
					  
					  self.$bvModal.hide('setpassword');
					}else{
						//self.$bvModal.hide('setpassword');
					  self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					  });
					
					}
					
				  })
				  .catch(function (error) {
					alert(error);
				  });
			}
		},
		resetSelectedForm(){
			this.register={
				new_password:'',
				conformpassword:'',
            };
			
			this.registerState={
				new_password:null,
				conformpassword:null,
			};
		},

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    scoped lang="scss">
	.shpmy{
		.close{
			display:none;
		}
	}
		
</style>
